import { ThemeProviderRender } from './middlewares';


export const mui = {
    renderChain: [
        [ThemeProviderRender, 45],
    ],
};
